import type { PathType } from './types';
import { getPath } from './types';

export const miscPaths: { [key: string]: PathType } = {
  // User Guide
  userGuides: getPath('/user-guides', ['sidebar.home', 'v2.userGuides.index']),
  userGuide: getPath('/user-guide', ['sidebar.home', 'v2.userGuide.index']),
  userGuideAdd: getPath('/user-guide/add', ['sidebar.home', 'v2.userGuide.index', 'action.add'])
};
